import { SxProps, Theme } from "@mui/material";

export const mergeSx = (a?: SxProps<Theme>, b?: SxProps<Theme>): SxProps<Theme> => {
  return [
    ...(Array.isArray(a) ? a : [a]),
    // You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
    ...(Array.isArray(b) ? b : [b]),
  ];
};
